import { Comment } from 't2-graphql-types';
import { MutationHookOptions } from '@apollo/client/react/types/types';
import getSortedCommentsForArticle from '../queries/getSortedCommentsForArticle';

export const getLikesMutationOptions = (articleId: string, userId?: string): MutationHookOptions => ({
  variables: { userId },
  update: (cache, { data: { updateComment } }) => {
    const existingComments: { sortedCommentsForArticle: Comment[] } | null = cache.readQuery({
      query: getSortedCommentsForArticle,
      variables: {
        userId,
        articleId,
      },
    });

    const updatedComments = existingComments?.sortedCommentsForArticle?.map((comment) => {
      if (comment.id === updateComment.id) {
        return updateComment;
      }
      return comment;
    });

    cache.writeQuery({
      query: getSortedCommentsForArticle,
      variables: {
        userId,
        articleId,
      },
      data: {
        sortedCommentsForArticle: updatedComments,
      },
    });

    return cache;
  },
});
